// 배포 뒤 열어 둔 탭에서 화면 파일을 못 받으면 가려던 주소를 새로 불러온다.
//
// 지금 이 관리자는 화면을 모두 정적으로 import 해서 처음에 한 번에 받는다 — 그래서 이 장치가
// 걸릴 일이 아직 없다. 화면을 () => import() 로 나눠 받게 바꾸는 순간부터 필요해서 미리 둔다
// (2026-11-05 지시: 프런트 전부에 같은 장치).
//
// 나눠 받는 화면은 파일 이름에 해시가 붙고, 배포하면 새 컨테이너에는 새 판 파일만 있다. 배포 전에
// 열어 둔 탭에서 메뉴를 누르면 옛 판 화면 파일이 404 가 나고 이동이 취소된다(자사몰에서 2026-11-05
// 확인). 가려던 주소를 통째로 다시 열면 새 index.html 이 새 판 파일을 가리킨다.
//
// 배포 중 1분 동안 두 판이 같이 서는 문제는 ALB 스티키 쿠키가 막는다(goldnara-infra 05-platform.yaml).
//
// 새로 불러온 뒤에도 또 실패하면 30초 안에는 다시 하지 않고 원래 오류를 둔다 — 무한 새로고침 방지.
//
// 골드나라 관리자 · 아우라 관리자에 같은 파일로 둔다. 자사몰 · 홈페이지 · 미디어허브에도 같은
// 동작의 파일이 있다(머리말만 다르다).

const KEY = 'stale-chunk-reload-at'
const WINDOW_MS = 30_000

// 브라우저마다 문구가 다르다 — 크롬 · 파이어폭스 · 사파리, 그리고 Vite 의 CSS 미리 받기.
const STALE_CHUNK =
  /Failed to fetch dynamically imported module|error loading dynamically imported module|Importing a module script failed|Unable to preload CSS/i

const mayReload = () => {
  try {
    const last = Number(sessionStorage.getItem(KEY) || 0)
    if (Date.now() - last < WINDOW_MS) return false
    sessionStorage.setItem(KEY, String(Date.now()))
  } catch {
    // 저장소가 막혀 있으면(사생활 보호 창 등) 한 번 시도는 한다
  }
  return true
}

export function reloadOnStaleChunk(router) {
  router.onError((error, to) => {
    if (!STALE_CHUNK.test(String(error?.message || ''))) return
    if (!mayReload()) return
    window.location.assign(to ? router.resolve(to.fullPath).href : window.location.href)
  })
}
